import React from 'react';
import MLRadioButton from './MLRadioButton';

const MLRadioContext = React.createContext({
  selectedValue: null,
  onChange: () => null,
});

export { MLRadioButton, MLRadioContext };
